module.exports = __webpack_public_path__ + "img/code_coop.e70c3294.png";